import { useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useTeamComposition = ({ projectId, card }) => {

    const [teamSummary, setTeamSummary] = useState([]);
    const [projectInfo, setProjectInfo] = useState([]);
    const [details, setDetails] = useState({ visible: false, data: {} });
    const [loader, setLoader] = useState({ project_info: false, team_comp: false });

    useEffect(() => {
        if (card === "project_info") {
            getProjectInfo();
        } else if (card === "team_composition") {
            GetTeamCompositionSummary();
        }
    }, [])

    const getProjectInfo = async () => {
        try {
            setLoader((prev) => ({ ...prev, project_info: true }));
            const payload = {
                project_id: projectId
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFO"), payload);
            if (res) {
                const data = res?.body?.data?.project_info?.[0];
                setProjectInfo(data);
                setLoader((prev) => ({ ...prev, project_info: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, project_info: false }));
        }
    }

    const GetTeamCompositionSummary = async () => {
        try {
            setLoader((prev) => ({ ...prev, team_comp: true }));
            const payload = {
                project_id: projectId
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTEAMCOMPOSITIONSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_composition_summary;
                setTeamSummary(_.sortBy(data, "category_name"));
                setLoader((prev) => ({ ...prev, team_comp: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, team_comp: false }));
        }
    }

    const getIcon = (key) => {
        if (key === "project_team") {
            return { icon: "fa-solid fa-users", color: "#3b82f6" };
        } else if (key?.toLowerCase()?.includes("dba")) {
            return { icon: "fa-solid fa-database", color: "#a855f7" };
        } else if (key?.toLowerCase()?.includes("devops")) {
            return { icon: "fa-solid fa-code-fork", color: "#eab308" };
        } else if (key?.toLowerCase()?.includes("qa")) {
            return { icon: "fa-solid fa-vial", color: "#06b6d4" };
        } else {
            return { icon: "fa-solid fa-user", color: "#6b7280" };
        }
    }

    return useMemo(() => ({
        teamSummary, getIcon, projectInfo, details, setDetails, GetTeamCompositionSummary, loader
    }), [teamSummary, getIcon, projectInfo, details, setDetails, GetTeamCompositionSummary, loader])
}